<p>
  datepicker-menu works!
</p>
